// 年月の比較よう関数

import { IYearMonth } from './interfaces/date';
import { ISalesResult } from './interfaces/salesResults';

/**
 * 日付の順に並び替えていく(デフォルトは降順)
 * @param isAsc '
 */
export const compareDateForTranslateExcel = (isAsc: boolean): ((a: ISalesResult, b: ISalesResult) => number) => {
  if (isAsc) {
    return (a: IYearMonth, b: IYearMonth): number => {
      if (a.year * 100 + a.month > b.year * 100 + b.month) {
        return 1;
      } else if (a.year * 100 + a.month === b.year * 100 + b.month) {
        return 0;
      } else {
        return -1;
      }
    };
  } else {
    return (a: IYearMonth, b: IYearMonth): number => {
      if (a.year * 100 + a.month < b.year * 100 + b.month) {
        return 1;
      } else if (a.year * 100 + a.month === b.year * 100 + b.month) {
        return 0;
      } else {
        return -1;
      }
    };
  }
};

/**
 * latestYearMonthData内の年月データ比較用関数
 * 日付の順に並び替えていく(デフォルトは降順)
 * @param isAsc '
 */
export const compareDateForLatestYearMonthData = (isAsc: boolean): ((a: string, b: string) => number) => {
  if (isAsc) {
    return (a: string, b: string): number => {
      const inputA = a.replace(/[年月]/g, '');
      const inputB = b.replace(/[年月]/g, '');
      const yearA = Number(inputA.split('_')[0]);
      const monthA = Number(inputA.split('_')[1]);
      const yearB = Number(inputB.split('_')[0]);
      const monthB = Number(inputB.split('_')[1]);
      if (yearA * 100 + monthA > yearB * 100 + monthB) {
        return 1;
      } else if (yearA * 100 + monthA === yearB * 100 + monthB) {
        return 0;
      } else {
        return -1;
      }
    };
  } else {
    return (a: string, b: string): number => {
      const inputA = a.replace(/[年月]/g, '');
      const inputB = b.replace(/[年月]/g, '');
      const yearA = Number(inputA.split('_')[0]);
      const monthA = Number(inputA.split('_')[1]);
      const yearB = Number(inputB.split('_')[0]);
      const monthB = Number(inputB.split('_')[1]);
      if (yearA * 100 + monthA < yearB * 100 + monthB) {
        return 1;
      } else if (yearA * 100 + monthA === yearB * 100 + monthB) {
        return 0;
      } else {
        return -1;
      }
    };
  }
};

/**
 * エクセルの転記処理専用：転記ログのソートを行う
 * 対象は、「変更履歴」、「未転記取引まとめ」
 * isAscがtrueの場合は昇順になる (デフォルトはtrue)
 * セル番号の比較処理を文字列のまま行うと、文字コードの関係で期待する順序にならないため、「セル番号」列だけ処理を分岐するようにしている
 * @param itemCount 項目数(比較する列数)
 * @param colInfo 列情報
 * @param cellNumberIndexes 「セル番号」列のindexの集合
 * @param isAsc 昇降順のフラグ
 */
export const compareTranscriptionLogOrder = (
  itemCount: number,
  colInfo: string[],
  cellNumberIndexes: number[],
  isAsc?: boolean
): ((a: string[], b: string[]) => number) => {
  if (!isAsc) isAsc = true;
  if (isAsc) {
    return (a: string[], b: string[]): number => {
      for (let i = 0; i < itemCount; i++) {
        // 列名がある行は位置を変えないようにする
        if (a[i] === colInfo[i] || b[i] === colInfo[i]) {
          return 0;
        }
        // セル番号が入っている列に対しての比較処理
        if (cellNumberIndexes.includes(i)) {
          // 正規表現を用いて、セル番号の文字列部分と数字部分を分割する
          const aSplitArray: string[] = a[i].split(/(\d+)/);
          const bSplitArray: string[] = b[i].split(/(\d+)/);
          // 文字列部分が一致していたら、数字部分の比較処理を行う
          if (aSplitArray[0] === bSplitArray[0]) {
            // 数字部分の判定
            if (Number(aSplitArray[1]) > Number(bSplitArray[1])) return 1;
            if (Number(aSplitArray[1]) < Number(bSplitArray[1])) return -1;
            return 0;
          }
          // 文字列部分の比較処理
          if (aSplitArray[0].localeCompare(bSplitArray[0]) === 1) return 1;
          if (aSplitArray[0].localeCompare(bSplitArray[0]) === -1) return -1;
          return 0;
        }
        // データの比較
        if (a[i] === b[i]) continue;
        if (a[i] > b[i]) return 1;
        if (a[i] < b[i]) return -1;
      }
      return 0;
    };
  } else {
    return (a: string[], b: string[]): number => {
      for (let i = 0; i < itemCount; i++) {
        // 列名がある行は位置を変えないようにする
        if (a[i] === colInfo[i] || b[i] === colInfo[i]) {
          return 0;
        }
        // セル番号が入っている列に対しての比較処理
        if (cellNumberIndexes.includes(i)) {
          // 正規表現を用いて、セル番号の文字列部分と数字部分を分割する
          const aSplitArray: string[] = a[i].split(/(\d+)/);
          const bSplitArray: string[] = b[i].split(/(\d+)/);
          // 文字列部分が一致していたら、数字部分の比較処理を行う
          if (aSplitArray[0] === bSplitArray[0]) {
            // 数字部分の判定
            if (Number(aSplitArray[1]) < Number(bSplitArray[1])) return 1;
            if (Number(aSplitArray[1]) > Number(bSplitArray[1])) return -1;
            return 0;
          }
          // 文字列部分の比較処理
          if (aSplitArray[0].localeCompare(bSplitArray[0]) === -1) return 1;
          if (aSplitArray[0].localeCompare(bSplitArray[0]) === 1) return -1;
          return 0;
        }
        // データの比較
        if (a[i] === b[i]) continue;
        if (a[i] < b[i]) return 1;
        if (a[i] > b[i]) return -1;
      }
      return 0;
    };
  }
};
